import getBaseService from "../api-services/baseApiService";
import { useLoading } from "../redux-services/LoadingContext";


const urlAuth = 'authen';
const urlSms = 'sms';
const urlUser = 'users';
const urlProducts = 'products';
const urlStores = 'stores';
const urlTransactions = 'transactions';
const urlMaster = 'master';
const urlMasterFiles = 'master/files';
const urlMasterCategories = 'master/categories';
const urlMasterProductGroups = 'master/product-groups';
const urlDashboard = 'dashboard';

export const useApiServices = () => {
    const { setLoading } = useLoading();
    const BaseService = getBaseService(setLoading);

    // ========================================================= //
    // =================== Authentication ====================== //
    // ========================================================= //
    const LoginAsync = async (payload: any) => {
        return await BaseService.post(`${urlAuth}/admin/login`, payload);
    };
    const AuthRefreshAsync = async () => {
        return await BaseService.get(`${urlAuth}/refresh`);
    };
    const AuthInfoAsync = async () => {
        return await BaseService.get(`${urlAuth}/info`);
    };
    const RegisterAsync = async (payload: any) => {
        return await BaseService.post(`${urlAuth}/register`, payload);
    };
    const ResetPasswordAsync = async (payload: any) => {
        return await BaseService.post(`${urlAuth}/resetpassword`, payload);
    };
    const ChangePasswordAsync = async (payload: { password: string }) => {
        return await BaseService.post(`${urlAuth}/resetpassword`, payload);
    };

    // ========================================================= //
    // ======================== Sms ============================ //
    // ========================================================= //
    const RequestOtpAsync = async (payload: any) => {
        return await BaseService.post(`${urlSms}/request`, payload);
    };
    const VerifyOtpAsync = async (payload: any) => {
        return await BaseService.post(`${urlSms}/verify`, payload);
    };

    // ========================================================= //
    // ======================== User =========================== //
    // ========================================================= //
    const GetUserByIdAsync = async (id: string) => {
        return await BaseService.get(`${urlUser}/${id}`);
    };
    const GetUserListAsync = async (params: any) => {
        return await BaseService.get(`${urlUser}`, params);
    };
    const UpdateUserByIdAsync = async (id: string, payload: any) => {
        return await BaseService.put(`${urlUser}/${id}`, payload);
    };
    const DeleteUserByIdAsync = async (id: string) => {
        return await BaseService.delete(`${urlUser}/${id}`);
    };
    const GetUserAsync = async (id: number) => {
        return await BaseService.get(`${urlUser}/${id}`);
    };
    const CreateUserAsync = async (payload: any) => {
        return await BaseService.post(`${urlUser}`, payload);
    };
    const GetUsersRecentTransactionsAsync = async (id: string) => {
        return await BaseService.get(`${urlUser}/${id}/recent-transactions`);
    };
    const GetConfigurationsAsync = async () => {
        return await BaseService.get(`${urlUser}/configurations`);
    };

    //products

    const GetProductsAsync = async (params: any) => {
        return await BaseService.get(`${urlProducts}`, params);
    };

    const GetProductsDetailsAsync = async (id: string) => {
        return await BaseService.get(`${urlProducts}/${id}`);
    };

    const GetProductsRecentTransactionsAsync = async (id: string) => {
        return await BaseService.get(`${urlProducts}/${id}/recent-transactions`);
    };

    const AddProductsAsync = async (params: any) => {
        return await BaseService.post(`${urlProducts}`, params);
    };

    const UpdateProductsAsync = async (id: string, params: any) => {
        return await BaseService.put(`${urlProducts}/${id}`, params);
    };

    const AddBankAccountAsync = async (euid: string, params: any) => {
        return await BaseService.post(`${urlMaster}/${euid}/bank-account`, params);
    };

    const GetBankAccountAsync = async (euid: string) => {
        return await BaseService.get(`${urlMaster}/${euid}/bank-account`);
    };

    const UpdateBankAccountAsync = async (euid: string, payload: any) => {
        return await BaseService.put(`${urlMaster}/${euid}/bank-account`, payload);
    };

    const GetStoresAsync = async (params: any) => {
        return await BaseService.get(`${urlStores}`, params);
    };

    const GetCategoriesAsync = async () => {
        return await BaseService.get(`${urlMasterCategories}`);
    }

    const GetProductGroupsAsync = async () => {
        return await BaseService.get(`${urlMasterProductGroups}`);
    }

    const AddProductGroupAsync = async (payload: any) => {
        return await BaseService.post(urlMasterProductGroups,payload)
    }

    const UpdateProductGroupAsync = async (id: string, payload: any) => {
        return await BaseService.put(`${urlMasterProductGroups}/${id}`,payload)
    }

    const GetStoresDetailAsync = async (id: string) => {
        return await BaseService.get(`${urlStores}/${id}`);
    };

    const GetRecentTransactionsAsync = async (id: string) => {
        return await BaseService.get(`${urlStores}/${id}/recent-transactions`);
    };

    const AddStoresAsync = async (payload: any) => {
        return await BaseService.post(`${urlStores}`, payload);
    };

    const UpdateStoresAsync = async (id: string, payload: any) => {
        return await BaseService.put(`${urlStores}/${id}`, payload);
    };

    const AddConfigurationsAsync = async (payload: any) => {
        return await BaseService.post(`${urlStores}/product-to-store-configurations`, payload);
    };

    const UpdateConfigurationsAsync = async (id: string, payload: any) => {
        return await BaseService.put(`${urlStores}/product-to-store-configurations/${id}`, payload);
    };

    const GetProductsByLocationAsync = async (payload: any) => {
        return await BaseService.post(`${urlProducts}/bylocation`, payload);
    };

    //transaction
    const CreateTransactionAsync = async (payload: any) => {
        return await BaseService.post(`${urlTransactions}`, payload);
    };
    const GetTransactionAsync = async (params: any) => {
        return await BaseService.get(`${urlTransactions}`, params);
    };
    const GetTransactionDetailsAsync = async (id: string) => {
        return await BaseService.get(`${urlTransactions}/${id}`);
    };
    const CreatePaymentAsync = async (payload: any) => {
        return await BaseService.post(`${urlTransactions}/payment`, payload);
    };
    const GetTransactionLogsAsync = async (id: string) => {
        return await BaseService.get(`${urlTransactions}/${id}/logs`);
    };
    const GetTransactionFilesAsync = async (id: string) => {
        return await BaseService.get(`${urlTransactions}/${id}/files`);
    };
    const ConfirmTransactionAsync = async (id: string, payload: any) => {
        return await BaseService.post(`${urlTransactions}/${id}/confirm`, payload);
    };
    const GetMasterTransactionStatus = async () => {
        return await BaseService.get(`${urlMaster}/transactionstatuses`);
    };
    const UpdateTransactionStatusAsync = async (id: string, payload: any) => {
        return await BaseService.put(`${urlTransactions}/${id}/status`, payload);
    };

    //files
    const UploadFileAsync = async (payload: FormData) => {
        return await BaseService.postForm(`${urlMasterFiles}`, payload);
    }
    const GetFileMetaDataAsync = async (id: string) => {
        return await BaseService.get(`${urlMasterFiles}/${id}/metadata`);
    }
    const GetFileContentAsync = async (id: string) => {
        return await BaseService.getFile(`${urlMasterFiles}/${id}/content`);
    }

    //comments

    const GetCommentAsync = async (euid: string) => {
        return await BaseService.get(`${urlMaster}/${euid}/comment`)
    }
    const AddCommentAsync = async (euid: string, payload: any) => {
        return await BaseService.post(`${urlMaster}/${euid}/comment`, payload)
    }
    const UpdateCommentAsync = async (euid: string, payload: any) => {
        return await BaseService.put(`${urlMaster}/${euid}/comment`, payload)
    }

    //addresses

    const GetAddressAsync = async (euid: string) => {
        return await BaseService.get(`${urlMaster}/${euid}/address`)
    }
    const AddAddressAsync = async (euid: string, payload: any) => {
        return await BaseService.post(`${urlMaster}/${euid}/address`, payload)
    }
    const UpdateAddressAsync = async (euid: string, payload: any) => {
        return await BaseService.put(`${urlMaster}/${euid}/address`, payload)
    }

    // ========================================================= //
    // ===================== Chat Heads ======================== //
    // ========================================================= //
    const GetChatHeadsAsync = async (params: any) => {
        return await BaseService.get(`/line/admin/chatheads`, params);
    };

    // ========================================================= //
    // ===================== Chat Messages ===================== //
    // ========================================================= //
    const GetChatMessagesAsync = async (userId: string, params: any) => {
        return await BaseService.get(`/line/admin/messages/${userId}`, params);
    };

    // ========================================================= //
    // ===================== Send Message ====================== //
    // ========================================================= //
    const SendMessageAsync = async (payload: { userId: string; message: string }) => {
        return await BaseService.post(`/line/admin/send`, payload);
    };

    // ========================================================= //
    // ===================== Send Image ======================== //
    // ========================================================= //
    const SendImageAsync = async (formData: FormData) => {
        return await BaseService.postForm(`/line/admin/send-image`, formData);
    };

    // ========================================================= //
    // ====================== Dashboard ======================== //
    // ========================================================= //
    const GetDashboardDailyAsync = async (params: { startDate: string; endDate: string }) => {
        return await BaseService.get(`${urlDashboard}/daily`, params);
    };
    const GetDashboardTopProductsAsync = async (params: { startDate: string; endDate: string; limit?: number }) => {
        return await BaseService.get(`${urlDashboard}/top-products`, params);
    };
    const GetDashboardTopStoresAsync = async (params: { startDate: string; endDate: string; limit?: number }) => {
        return await BaseService.get(`${urlDashboard}/top-stores`, params);
    };
    const GetDashboardSummaryAsync = async (params: { startDate: string; endDate: string }) => {
        return await BaseService.get(`${urlDashboard}/summary`, params);
    };

    return {
        LoginAsync,
        AuthRefreshAsync,
        AuthInfoAsync,
        RegisterAsync,
        ResetPasswordAsync,
        ChangePasswordAsync,
        RequestOtpAsync,
        VerifyOtpAsync,
        GetUserByIdAsync,
        UpdateUserByIdAsync,
        DeleteUserByIdAsync,
        GetUserAsync,
        CreateUserAsync,
        GetProductsAsync,
        GetProductsByLocationAsync,
        CreateTransactionAsync,
        GetTransactionAsync,
        UploadFileAsync,
        GetFileMetaDataAsync,
        GetFileContentAsync,
        CreatePaymentAsync,
        GetStoresAsync,
        GetUserListAsync,
        GetTransactionDetailsAsync,
        GetStoresDetailAsync,
        GetTransactionLogsAsync,
        GetTransactionFilesAsync,
        ConfirmTransactionAsync,
        AddStoresAsync,
        GetRecentTransactionsAsync,
        AddConfigurationsAsync,
        UpdateConfigurationsAsync,
        UpdateStoresAsync,
        AddProductsAsync,
        GetCategoriesAsync,
        GetProductsDetailsAsync,
        GetProductsRecentTransactionsAsync,
        UpdateProductsAsync,
        AddBankAccountAsync,
        GetBankAccountAsync,
        UpdateBankAccountAsync,
        GetCommentAsync,
        AddCommentAsync,
        UpdateCommentAsync,
        GetAddressAsync,
        UpdateAddressAsync,
        AddAddressAsync,
        GetUsersRecentTransactionsAsync,
        GetConfigurationsAsync,
        GetMasterTransactionStatus,
        UpdateTransactionStatusAsync,
        GetProductGroupsAsync,
        AddProductGroupAsync,
        UpdateProductGroupAsync,
        GetChatHeadsAsync,
        GetChatMessagesAsync,
        SendMessageAsync,
        SendImageAsync,
        GetDashboardDailyAsync,
        GetDashboardTopProductsAsync,
        GetDashboardTopStoresAsync,
        GetDashboardSummaryAsync,
    };
};
